import SearchPageHeaderMeta from './components/SearchPageHeaderMeta/SearchPageHeaderMeta';
import SeoSearchPageHeaderMeta from './components/SeoSearchPageHeaderMeta/SeoSearchPageHeaderMeta';

type Props = {
    canonicalURL: string;
    displayLocation: string;
    displaySearchTerm: string;
    isCollectionsPage: boolean;
    isSEOSearchPage: boolean;
    page: number;
    searchTerm: string;
    totalFound: number;
};

export const SearchPageHeaderMetaWrapper = ({
    canonicalURL,
    displayLocation,
    displaySearchTerm,
    isCollectionsPage,
    isSEOSearchPage,
    page,
    searchTerm,
    totalFound,
}: Props) => {
    return (
        <>
            {isSEOSearchPage || isCollectionsPage ? (
                <SeoSearchPageHeaderMeta
                    canonicalURL={canonicalURL}
                    displayLocation={displayLocation}
                    displaySearchTerm={displaySearchTerm}
                    totalFound={totalFound}
                />
            ) : (
                <SearchPageHeaderMeta
                    page={page}
                    searchTerm={searchTerm}
                />
            )}
        </>
    );
};
